export enum AttributeType {
    CompanyCoreValues = 1,
    CompanyIdentity = 2,
    CompanyCulture = 3
}